<template>
  <div>
    <div class="mb-6">
      <a
        class="text-decoration-none text-subtitle-2 font-weight-bold"
        @click.prevent="returnBack"
      >
        <v-icon
          color="primary"
          dense
          class="mr-2"
        >
          {{ icons.mdiArrowLeft }}
        </v-icon>
        Kembali
      </a>
    </div>
    <MainCard v-if="!isLoadingTable">
      <template v-slot:body>
        <DataTablePagination
          title="Siswa/i Paling Aktif"
          subtitle="Daftar siswa paling aktif"
          :no-add-button="noAddButton"
          :headers="headers"
          :items="students"
          :search="search"
          :page="page"
          :total-items="totalItems"
          :total-pages.sync="totalPages"
          :is-loading="isLoadingData"
          @live-search="searchHandler"
          @change-page="paginationHandler"
        ></DataTablePagination>
      </template>
    </MainCard>
    <SkeletonLoaderTable v-else></SkeletonLoaderTable>
  </div>
</template>

<script>
import DataTablePagination from '@/views/components/DataTablePagination.vue'
import MainCard from '@/views/components/MainCard.vue'
import SkeletonLoaderTable from '@/views/components/SkeletonLoaderTable.vue'
import { mdiArrowLeft } from '@mdi/js'

export default {
  name: 'BookPurchaseHistory',
  components: {
    MainCard,
    DataTablePagination,
    SkeletonLoaderTable,
  },
  data() {
    return {
      icons: {
        mdiArrowLeft,
      },
      noAddButton: true,
      headers: [
        { text: 'No', value: 'index' },
        { text: 'Nama', value: 'photo-user' },
        { text: 'Asal Sekolah', value: 'school' },
        { text: 'Aktifitas', value: 'activity' },
        { text: 'Buku Dipinjam', value: 'borrow_book' },
        { text: 'E-Learning', value: 'elearning' },
        { text: 'Bank Soal', value: 'question_bank' },
      ],
      students: [],
      page: 1,
      search: '',
      totalItems: 0,
      totalPages: 0,
      service: 'studentactive',
      isLoadingData: false,
      isLoadingTable: true,
      filterQuery: {
        search: '',
      },
    }
  },
  watch: {
    page: {
      handler() {
        this.listActiveStudent()
      },
    },
    search: {
      handler() {
        this.listActiveStudent()
      },
    },
  },
  mounted() {
    this.listActiveStudent()
  },
  methods: {
    async listActiveStudent(params = {}) {
      this.isLoadingData = true
      await this.$services.ApiServices.list(this.service, {
        ...params,
        page: this.page,
      }).then(({ data }) => {
        this.students = data.data.map((student, index) => ({
          ...student,
          index: index + 1,
        }))
        this.totalItems = data.meta.total
        this.totalPages = data.meta.last_page
      })
      this.isLoadingData = false
      this.isLoadingTable = false
    },
    async searchHandler(search) {
      this.filterQuery.search = search
      this.page = 1
      await this.listActiveStudent(this.filterQuery)
    },
    paginationHandler(pageNumber) {
      this.page = pageNumber
    },
    returnBack() {
      this.$router.back()
    },
  },
}
</script>

<style>
</style>
